'use client';

import { motion } from 'framer-motion';
import type { PropsWithChildren, ReactElement } from 'react';
import type PropsWithClassname from 'types/props-with-classname';

export default function PageWrapper({
  children,
  className,
}: PropsWithChildren<PropsWithClassname>): ReactElement {
  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      className={className}
      exit={{ opacity: 0, y: 20 }}
      initial={{ opacity: 0, y: 20 }}
    >
      {children}
    </motion.div>
  );
}
